import {
  AccessTimeOutlined,
  MoneyOffOutlined,
  WeekendOutlined,
  AutoAwesomeOutlined,
  PeopleAltOutlined,
  PersonOutlined,
  ApartmentOutlined,
  StorefrontOutlined,
  LocalOfferOutlined,
  LoginOutlined,
  PetsOutlined,
  WorkOutline,
  EngineeringOutlined,
  GavelOutlined,
  Inventory2Outlined,
  InventoryOutlined,
  LandscapeOutlined,
} from '@mui/icons-material';

export const specialIconMap: Record<string, React.ComponentType<any>> = {
  UnitFromDeveloper: ApartmentOutlined,
  Urgentsale: AccessTimeOutlined,
  Breakdownpayment: MoneyOffOutlined,
  Fullyfurnished: WeekendOutlined,
  Fullyequipment: Inventory2Outlined,
  FullFitted: Inventory2Outlined,
  NewProject: AutoAwesomeOutlined,
  Sellwithtenant: PeopleAltOutlined,
  Selldownpayment: StorefrontOutlined,
  Presale: StorefrontOutlined,
  SalebyOwner: PersonOutlined,
  Cheapprice: LocalOfferOutlined,
  '2ndhandCheapprice': LocalOfferOutlined,
  moveinready: LoginOutlined,
  petallow: PetsOutlined,
  Readytooperate: WorkOutline,
  Mortgagebreach: GavelOutlined,
  'NewConstructed-Readytouse': EngineeringOutlined,
  'NewConstructed-ReadytoMovein': EngineeringOutlined,
  'NewDecorated-Readytomovein': EngineeringOutlined,
  'NewDecorated-Readytouse': EngineeringOutlined,
  Partlyequipment: InventoryOutlined,
  Serviceapartment: ApartmentOutlined,
  landFilled: LandscapeOutlined,
  Catfriendly: PetsOutlined,
  Dogfriendly: PetsOutlined,
};
